<template>
  <div class="admin-button-container">
    <button
      :style="{
        color: textColor,
        backgroundColor: backgroundColor,
        border: borderButton,
        width: block ? '100%' : '136px',
      }"
      @click="$emit('click', $event)"
    >
      <div class="button-wrapper">
        <div class="load" v-if="loading"></div>

        <slot v-else />
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
    },
    block: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    textColor() {
      if (this.outline) {
        return "rgba(39, 174, 96, 1)";
      }

      switch (this.color) {
        case "green":
          return "#FFFFFF";

        default:
          return "#000000";
      }
    },
    backgroundColor() {
      switch (this.color) {
        case "green":
          return "rgba(39, 174, 96, 1)";

        default:
          return "#FFFFFF";
      }
    },
    borderButton() {
      if (this.outline) {
        return "1px solid rgba(39, 174, 96, 1)";
      }

      if (this.border) {
        return "1px solid rgba(185, 185, 185, 1)";
      } else {
        return "none";
      }
    },
  },
};
</script>

<style scoped>
.admin-button-container {
  /* max-height: 21px; */
}
button {
  text-transform: uppercase;
  border: none;
  background-color: red;
  border-radius: 4px;
  width: 136px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: bold;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  min-height: 21px;
}
</style>
